<template>
  <v-snackbar
    v-bind="$attrs"
    :model-value="modelValue"
    app rounded="0" :timeout="-1"
    min-width="100%"
    :class="[FILTERS_ACTIVE_BAR_CLASS, 'cursor-pointer']"
    content-class="full-width d-flex align-center"
    color="bg-neutral800 text-neutral0"
  >
    <v-container class="max-app-width pa-0">
      <v-row dense align="center">
        <v-col cols="auto" class="d-flex align-center">
          <PhFadersHorizontal class="text-h5 mr-2" weight="fill" />
          <span v-text="$tc('common.filters_active', modelValue?.length ?? 0)" />
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="d-flex align-center">
          <BrandButton icon size="small" variant="text">
            <PhCaretUp class="text-h6" />
          </BrandButton>
        </v-col>
      </v-row>
      <v-spacer />
    </v-container>
  </v-snackbar>
</template>

<script setup>
import { defineProps } from 'vue'
import { PhCaretUp, PhFadersHorizontal } from '@phosphor-icons/vue'
import { FILTERS_ACTIVE_BAR_CLASS } from '@/composables/useStickyBottom'

defineProps({
  modelValue: {
    type: [Boolean, Array],
    default: false,
  },
})
</script>

<style lang="scss" scoped>
.active-filters-notice :deep() {
  .v-snack__wrapper {
    margin: 0;
  }

  .v-snack__action {
    display: none;
  }
}
</style>
